import { writable, get } from "svelte/store";
import { localVideoStore, toggleLocalTorch } from "./localVideoStore";
import { sendSocketMessage } from "./socketStore";
import { roomStore } from "./roomStore";
export const localTorchState = writable({
    torchOn: false,
    origin: null,
});
export async function turnOnLocalTorchFromSelf() {
    await setTorch(true, "self");
}
export async function turnOffLocalTorchFromSelf() {
    await setTorch(false, "self");
}
export async function turnOnLocalTorchFromRemote() {
    await setTorch(true, "conseiller");
}
export async function turnOffLocalTorchFromRemote() {
    await setTorch(false, "conseiller");
}
async function setTorch(turnOn, origin) {
    const stream = get(localVideoStore);
    const room = get(roomStore);
    if (!stream || !room)
        return false;
    const success = await toggleLocalTorch(turnOn);
    if (!success)
        return false;
    localTorchState.set({ torchOn: turnOn, origin });
    if (origin === "self") {
        sendSocketMessage({
            room: room.id,
            action: turnOn ? "torchOn" : "torchOff",
            type: "video",
        });
    }
    return true;
}
